import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UuidService } from 'src/app/services';

@Component({
  selector: 'app-kyc-primary-contact-person-modal',
  templateUrl: './kyc-primary-contact-person-modal.component.html',
  styleUrls: ['./kyc-primary-contact-person-modal.component.scss']
})
export class KycPrimaryContactPersonModalComponent {

  
    constructor(private uuidService: UuidService) { }
  
    fg: FormGroup = new FormGroup({
      id: new FormControl(this.uuidService.generateUUID()),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email])
    });

}
